import React from 'react';
import { Col } from 'react-bootstrap';
import { decodeForDisplay } from '../helpers/functions'

const Article = (props) => {
        return (
            <div>
                <div><Col xs={12} md={4}>
                    <div className="article-container">
                        <div className="article" >
                            <h3 className="title"><a href={props.article.link} target="_blank">{props.article.articleTitle}</a></h3>
                            <p className="abstract">{decodeForDisplay(props.article.abstract)}</p>
                            <p className="publisher">{props.article.publisher}</p>
                            <p className="date">{props.article.date}</p>
                        </div>
                    </div>
                </Col>
                </div>
            </div>
        )
    }
export default Article;


// WEBPACK FOOTER //
// ./src/components/Article.js